import styled from 'styled-components';

export const ContentHeader = styled.div`
    margin-bottom: 16px;
    .desc {
        color: rgba(0, 0, 0, 0.25);
    }
`;

export const RoleTag = styled.div`
    border-radius: 42px;
    padding: 2px 8px;
    ${(props) =>
        props.sender === 1 || props.sender === '1' ? `color: #C97C00;` : `background: #E6F3FF;`}
    ${(props) =>
        props.sender === 1 || props.sender === '1' ? `background: #FFEBA3;` : `color: #1A6EFF;`}
`;
